import React, { useEffect, useState } from 'react';
import { useReveal } from '../lib/useReveal';
export function FinalCTASection() {
  const [ref, vis] = useReveal();
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) return 15 * 60;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="bg-brand-alternate py-8 md:py-10 px-4 sm:px-6 border-t border-brand-border-soft" data-id="element-109">
      <div className="container mx-auto max-w-2xl" data-id="element-110">
        <div ref={ref} className={`reveal text-center ${vis ? 'is-visible' : ''}`} data-id="element-111">
          <div className="mb-5 flex flex-wrap justify-center items-center gap-2 text-brand-cta font-bold text-base md:text-xl tracking-widest uppercase" data-id="element-112">
            <span data-id="element-113">⏰ EL PRECIO CIERRA EN:</span>
            <span className="font-serif bg-white px-3 py-1 rounded border border-brand-border-soft shadow-sm" data-id="element-114">
              {hours.toString().padStart(2, '0')} hs :{' '}
              {minutes.toString().padStart(2, '0')} min :{' '}
              {seconds.toString().padStart(2, '0')} seg
            </span>
          </div>

          <div className="mb-6" data-id="element-115">
            <div className="bg-brand-footer border-2 border-brand-accent rounded-[20px] p-6 md:p-8 text-left relative overflow-hidden shadow-premium" data-id="element-116">
              <div className="absolute top-0 right-0 bg-brand-cta text-white font-bold text-[10px] px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-117">
                ⭐ OFERTA DE RELANZAMIENTO
              </div>
              <h3 className="text-xl md:text-2xl font-serif font-bold text-white mb-1 pr-24" data-id="element-118">
                🏆 MEGAPACK CÓDIGO FÉRTIL
              </h3>
              <p className="text-brand-border-soft font-bold text-sm mb-5" data-id="element-119">
                6 Tomos + 6 Bonos + Kit Ritual Premium
              </p>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-120">
                <div className="flex flex-col" data-id="element-121">
                  <span className="text-white/50 line-through text-lg font-bold" data-id="element-122">
                    $89.000
                  </span>
                  <p className="text-4xl font-extrabold text-white leading-none" data-id="element-123">
                    $22.990 <span className="text-base text-white/80" data-id="element-124">ARS</span>
                  </p>
                </div>
                <a href="https://academiaholisticaargentina.com/cart/48905855009018:1" target="_blank" rel="noopener noreferrer" className="inline-block py-4 px-6 rounded-full text-white font-bold text-sm tracking-widest uppercase text-center transition-all bg-brand-cta hover:bg-brand-cta-hover shadow-medium hover:-translate-y-1" data-id="element-125">
                  → QUIERO MI MEGAPACK
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-brand-subheading text-xs sm:text-sm font-medium" data-id="element-126">
            <span className="flex items-center gap-1.5" data-id="element-127">
              🔒 Pago 100% seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-128">
              ⚡ Acceso en 5 minutos
            </span>
            <span className="flex items-center gap-1.5" data-id="element-129">
              🛡️ Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-130">
              💳 Mercado Pago | Tarjeta | Transferencia
            </span>
          </div>
        </div>
      </div>
    </section>;
}